module.exports = __webpack_public_path__ + "media/images/icons/up-arrow-809d132274d89f1e6de8ae9f3e00499e.svg";